import React from 'react';
import { Button } from '../../../../../components/Common/UI/Button';
import SearchItem from '../SearchItem';
import { SearchKeyEnum, SearchKeyType, useGlobalSearchProvider } from '../../../../context/globalSearch';
import { useJobDetailsProvider } from '../../../../context/jobDetails';
import { JobSubTableAccount } from '../../../Pages/JobStatus/Details/TabsContent/subTableConfig';

export const highlightMatch = (text: string, searchQuery: string) => {
  const parts = text.split(new RegExp(`(${searchQuery})`, 'gi'));

  return parts.map(part =>
    part.toLowerCase() === searchQuery.toLowerCase() ? <strong key={crypto.randomUUID()}>{part}</strong> : part,
  );
};

interface GroupItemProps {
  title: string;
  fieldName: SearchKeyType;
  items: JobSubTableAccount[];
}

function GroupItem({ title, items, fieldName }: GroupItemProps) {
  const { searchTemp, handleSearchApplied, handleOpen } = useGlobalSearchProvider();
  const { handleSelectedTable } = useJobDetailsProvider();

  if (!items.length) return null;

  const handleClick = (search: string | number, field: SearchKeyType) => {
    handleSearchApplied({ search, field });
    handleOpen(false);

    // Set table to show everything when click on search item.
    handleSelectedTable({ row: 'ACCOUNTS', column: 'total' });
  };

  return (
    <div className="flex flex-col gap-2">
      <SearchItem variant="title" counter={items.length}>
        {title}
      </SearchItem>
      {items.slice(0, 5).map(item => (
        <SearchItem
          key={`${item?.[fieldName]}${item.id}`}
          onClick={() => handleClick(item?.[fieldName] || '', fieldName)}
        >
          {highlightMatch((item?.[fieldName] || '-').toString(), searchTemp)}
          {/* If need to display without highlight:  {item?.[fieldName] || '-'} */}
        </SearchItem>
      ))}
      {items.length >= 5 ? (
        <div className="flex justify-end">
          <Button size="auto" variant="link" onClick={() => handleClick(searchTemp, fieldName)}>
            view all results
          </Button>
        </div>
      ) : null}
    </div>
  );
}

export interface SearchResultsProps {
  searchResults: Record<SearchKeyType, JobSubTableAccount[]>;
}

function SearchGroups({ searchResults }: SearchResultsProps) {
  return (
    <div className="mt-4 flex flex-col gap-4">
      {Object.entries(searchResults).map(([field, items]) => (
        <GroupItem
          key={field}
          fieldName={field as SearchKeyType}
          title={SearchKeyEnum[field as SearchKeyType]}
          items={items}
        />
      ))}
    </div>
  );
}

export default SearchGroups;
